import { render, staticRenderFns } from "./AmbientSound.vue?vue&type=template&id=4649d2fa&scoped=true&"
import script from "./AmbientSound.vue?vue&type=script&lang=js&"
export * from "./AmbientSound.vue?vue&type=script&lang=js&"
import style0 from "./AmbientSound.vue?vue&type=style&index=0&id=4649d2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4649d2fa",
  null
  
)

export default component.exports